import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import useClickOutside from "../../hooks/useClickOutside";
import { useAuthInfo } from "../../context/AuthContext";

const ProfileMenu = ({ menuOpen, setMenuOpen, avatarClickedRef }) => {
  const menuRef = useClickOutside(() => setMenuOpen(false), avatarClickedRef);

  const { userInfo, logout } = useAuthInfo();
  const history = useHistory();

  const handleLinkClick = (link) => {
    avatarClickedRef.current = true;
    setMenuOpen(false);
    history.push(link);
  };

  useEffect(() => {
    if (menuOpen) {
      menuRef.current.focus();
    }
  }, [menuOpen, menuRef]);

  return (
    <div
      ref={menuRef}
      id="dropdown-menu-wrapper"
      className={"avatar-dropdown-content " + (menuOpen ? "show" : "hide")}
      tabIndex="0"
    >
      <h2 className="profile-username">{`${userInfo?.first_name} ${userInfo?.last_name}`}</h2>
      <div
        onClick={() => handleLinkClick(`/organization/${userInfo?.org_id}`)}
        className="org"
      ></div>

      <div
        className="nav-link"
        onClick={() => handleLinkClick(`/user/${userInfo?.user_id}`)}
      >
        My Profile
      </div>
      {userInfo?.role?.name !== "user" ? (
        <div
          className="nav-link"
          onClick={() => handleLinkClick(`/organization/${userInfo?.org_id}`)}
        >
          My Account
        </div>
      ) : null}

      <hr />

      <div onClick={logout} className="nav-link">
        Sign Out
      </div>
    </div>
  );
};

export default ProfileMenu;
